

$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('collections-list-template', theme.FeaturedCollections);
  sections.register('collection-row-section', theme.CollectionRows);
  sections.register('collection-template', theme.Collection);
  sections.register('header-section', theme.HeaderSection);
  sections.register('list-collections-template', theme.ListCollections);
  sections.register('map-section', theme.Maps);
  sections.register('product-template', theme.Product);
  sections.register('search-template', theme.Search);
  sections.register('slideshow-section', theme.SlideshowSection);
});
$(document).ready(function(){
  $('#oi-year-make-model-information').val($('.oi-collection-title').text()).trigger('change');
  $('.oi-make-model-year-title-main').text($('.oi-collection-title').text());
  $('.oi-variant-wrapper input').on("change",function(){
    var variant_id,options_id;
    variant_id = $(this).val();
    $('#productSelect-product-template option').each(function(){
      options_id = $(this).val();
      if(variant_id == options_id){
        $(this).prop('selected',true);
        $(this).parent().trigger('click');
      }
    });
  });
  $('.oi-menu-toggle').click(function(e){
    e.preventDefault();
    $('.oi-mobile-navigation-wrapper').addClass('oi-nav-opened');
  });
  $('.oi-mobile-nav-close-wrapper .oi-mobile-close-btn').click(function(){
    $('.oi-mobile-navigation-wrapper').removeClass('oi-nav-opened');
  });
});
$(document).ready(function(){
  var data_currency = $('.cart_drawer').attr('data-curency');
  $('.product-form__cart-submit').click(function(e){
    e.preventDefault();
    if(!$('.oi-collection-title').text()){
      if(!$('.easysearch-fitment-link').length){
        if($('.easysearch-fitment-search-widget').hasClass('easysearch-hidden')){
          $('#oi-year-make-model-information').val($('.easysearch-fitment-params.easysearch-fitment-text').text()).trigger('change');
          $('.oi-make-model-year-title-main').text($('.easysearch-fitment-params.easysearch-fitment-text').text());
            var data = $(this).parents('form').serialize();
              $.ajax({
              url:'/cart/add',
              type:'POST',
              dataType: 'HTML',
              data:data,
              success: function(response){
                $('.site-header_cart').html($(response).find('.site-header_cart').html())
                $('.cart_drawer').html($(response).filter('.cart_drawer').html()).addClass('drawer_open');
                $('body').addClass('cart_drawer_open'); 
                setTimeout(function() {
                  jQuery.getJSON('/cart.js', function(cart) {
                    jQuery(".cart-count").html(cart.item_count);
                  });
                }, 200);
              }
            });
          $('.oi-note-for-select-ymm').addClass('hide');
        }
        else{
          $('.oi-not-for-select-suitable-product').addClass('hide')
          $('.oi-note-for-select-ymm').removeClass('hide');
        }
        $('.oi-not-for-select-suitable-product').addClass('hide')
      }
      else{
        $('.oi-note-for-select-ymm').addClass('hide');
        $('.oi-not-for-select-suitable-product').removeClass('hide');
      }
    }
    else {
    var data = $(this).parents('form').serialize();
     $.ajax({
        url:'/cart/add',
        type:'POST',
        dataType: 'HTML',
        data:data,
        success: function(response){
          $('.site-header_cart').html($(response).find('.site-header_cart').html())
          $('.cart_drawer').html($(response).filter('.cart_drawer').html()).addClass('drawer_open');
          $('body').addClass('cart_drawer_open');
          setTimeout(function() {
            jQuery.getJSON('/cart.js', function(cart) {
                jQuery(".cart-count").html(cart.item_count);
            });
         }, 200);
        }
      });
    }
  });
  $(document).on('click','.cart__remove',function(e){
    e.preventDefault();
    var url = $(this).attr('href');
    $.ajax({
      url:url,
      type:'GET',
      success: function(response){
        $('.site-header_cart').html($(response).find('.site-header_cart').html())
        $('.cart_drawer').html($(response).filter('.cart_drawer').html()).addClass('drawer_open');
        $('body').addClass('cart_drawer_open');
          setTimeout(function() {
            jQuery.getJSON('/cart.js', function(cart) {
                jQuery(".cart-count").html(cart.item_count);
            });
         }, 200);
      }
    });
  });
  $(document).on('click','.add',function(e){
    $(this).prev().val(+$(this).prev().val() + 1);
    var data = $(this).parents('.cart1').serialize();
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update',
      data: data,
      dataType: 'HTML',
      success: function(data) {
        $('.site-header_cart').html($(data).find('.site-header_cart').html())
        $('.cart_drawer').html($(data).filter('.cart_drawer').html()).addClass('drawer_open');
        $('body').addClass('cart_drawer_open');
          setTimeout(function() {
            jQuery.getJSON('/cart.js', function(cart) {
                jQuery(".cart-count").html(cart.item_count);
            });
         }, 200);
      }
    });
  });
  $(document).on('click','.sub',function(e){
    if ($(this).next().val() > 1) {
      if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1); 
      var data = $(this).parents('.cart1').serialize();
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update',
        data: data,
        dataType: 'HTML',
        success: function(data) {
          $('.site-header_cart').html($(data).find('.site-header_cart').html())
          $('.cart_drawer').html($(data).filter('.cart_drawer').html()).addClass('drawer_open');
          $('body').addClass('cart_drawer_open');
          setTimeout(function() {
            jQuery.getJSON('/cart.js', function(cart) {
                jQuery(".cart-count").html(cart.item_count);
            });
         }, 200);
        }
      });
    }
  });
  $(document).on('click', '.site-header__cart', function(e){
    e.preventDefault();
    $('.cart_drawer').addClass('drawer_open');
    $('body').addClass('cart_drawer_open');
  });
  $(document).on('click', '.drawer_close', function(e){
    e.preventDefault();
    $('.cart_drawer').removeClass('drawer_open');
    $('body').removeClass('cart_drawer_open');
  });
  $('.oi-open-color-code-popup').click(function(e){ 
    e.preventDefault();
    $('.oi-not-sure-info-popup-wrapper').fadeIn();
  });
  $('.oi-not-sure-popup-close .oi-popup-close-btn').click(function(){
    $('.oi-not-sure-info-popup-wrapper').fadeOut();
  });
  $('.oi-featured-model').click(function(e){
  e.preventDefault();
  $('.oi-model-year-popup-wrapper').fadeIn();
    $('.oi-popup-make-name').text($(this).attr('data-make'));
    $('.oi-popup-model-name').text($(this).attr('data-model'));
    $(this).siblings().removeClass('oi-active-model');
     $(this).addClass('oi-active-model');
  });
  $('.oi-model-year-popup-year-selector').on('change',function(){
  var oi_selected_year,oi_selected_model,oi_selected_make,oi_final_url;
    oi_selected_year = $(this).val();
    if(oi_selected_year != 'Year'){ 
      oi_selected_model = $('.oi-featured-model.oi-active-model').attr('data-model');
      oi_selected_make =  $('.oi-featured-model.oi-active-model').attr('data-make');
      oi_final_url = '/collections'+'/'+oi_selected_year+'-'+oi_selected_make+'-'+oi_selected_model;
      $('.oi-model-year-popup-submit-btn').attr('href',oi_final_url);
    }
  });
  $('.oi-model-year-popup-close .oi-popup-close-btn').click(function(){
    $('.oi-model-year-popup-wrapper').fadeOut();
  });
  $('.oi-single-automotive-make').click(function(e){
    e.preventDefault();
    var oi_make_name = $(this).attr('data-make');
    $('.oi-aam-model-year-popup-header h4 .oi-aam-popup-make-name').text(oi_make_name);
    $('.oi-aam-model-year-popup-wrapper').fadeIn();
    $(this).parents('.oi-automotive-item-wrapper').siblings().find('.oi-single-automotive-make').removeClass('oi-active-make');
    $('.oi-single-featured-make').removeClass('oi-active-make');
     $(this).addClass('oi-active-make');
    $('#oi-easysearch_field_10017').val('').trigger('change');
  });
  $('.oi-single-featured-make').click(function(e){
    e.preventDefault();
    var oi_featured_make_name = $(this).attr('data-make');
    $('.oi-aam-model-year-popup-header h4 .oi-aam-popup-make-name').text(oi_featured_make_name);
    $('.oi-aam-model-year-popup-wrapper').fadeIn();
    $(this).parents('.oi-featured-make-model-item-wrapper').siblings().find('.oi-single-featured-make').removeClass('oi-active-make');
    $('.oi-single-automotive-make').removeClass('oi-active-make');
     $(this).addClass('oi-active-make');
    $('#oi-easysearch_field_10017').val('').trigger('change');
  });
  $('.oi-aam-model-year-popup-close .oi-popup-close-btn').click(function(){
    $('.oi-aam-model-year-popup-wrapper').fadeOut();
  });
  if($('.oi-collection-title').text()){
    $('.oi-mmy-info-wrapper-product-page').remove();
  }
   $('#oi-easysearch_field_10017').on('change',function(){
       setTimeout(function(){
        var selected_make_val, easymakeval;
         if($('.oi-single-automotive-make.oi-active-make').attr('data-make')){
           selected_make_val= $('.oi-single-automotive-make.oi-active-make').attr('data-make');
         }
         else if ($('.oi-single-featured-make.oi-active-make').attr('data-make')){
           selected_make_val= $('.oi-single-featured-make.oi-active-make').attr('data-make');
         }
        $('#oi-easysearch_field_10018 option').each(function(){ 
          easymakeval = $(this).val();
          if(selected_make_val == easymakeval){
            $(this).prop('selected', true);
            easysearch.jq(this).parent().val(selected_make_val).trigger("change");           
           }
        }); 
      },300);
    });
});